export const SITE = {
  CONNECTION_ERROR: "CONNECTION_ERROR",
};
